var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters } from '@pacem/pacem-core';
import { PacemWidgetElement, buildWidgetMetadata } from '../types';
import { EXPRESSION_METADATA_TYPE } from '../../scaffolding/types';
//namespace Pacem.Components.Cms {
const DATA_METADATA = {
    display: { icon: 'timer', name: 'Clock', description: 'Timer widget.' },
    props: [
        {
            prop: 'interval', type: EXPRESSION_METADATA_TYPE, display: {
                name: 'Interval (msec)'
            }, extra: {
                selector: '.' + PCSS + '-widget', step: 1000
            },
            validators: [{
                    type: 'range', errorMessage: 'Negative numbers not allowed', params: { min: 0 }
                }]
        }
    ]
};
let PacemWidgetClockElement = class PacemWidgetClockElement extends PacemWidgetElement {
    constructor() {
        super(buildWidgetMetadata(DATA_METADATA));
        this.interval = 0;
    }
};
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Number })
], PacemWidgetClockElement.prototype, "interval", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemWidgetClockElement.prototype, "time", void 0);
PacemWidgetClockElement = __decorate([
    CustomElement({
        tagName: P + '-widget-clock', template: `<${P}-timer interval="{{ :host.interval }}" on-tick="{{ :host.time = Date.now() }}"></${P}-timer>`
    })
], PacemWidgetClockElement);
export { PacemWidgetClockElement };
